export const mockGeolocationApiKey = {
  geolocationApiKey: '<API_KEY_GOES_HERE>'
};

export default mockGeolocationApiKey;
